function HydrateCounterBidingTooltip() {
  return (
    <span>Similar to the hydrate parameter on the tracking links, this setting can always enable or disable counter bidding for this CLink's campaign.</span>
  );
}

export default HydrateCounterBidingTooltip;